import styled, { css } from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';

const { devices, spaces, colors, fontSizes } = theme;

const StyledTrustPilotBannerSection = styled.div`
  margin-top: ${spaces.largeX}px;
  max-width: ${spaces.large24X * 8 + 80}px;
  width: 90%;
  background: ${colors.white};
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: space-between;
  align-items: center;
  @media ${devices.tablet} {
    width: 100%;
    padding: ${spaces.regular}px;
    gap: 8px;
    margin-top: ${spaces.small}px;
  }
`;
const StyledIncLogoSection = styled.div`
  img {
    width: 100px;
  }
  @media ${devices.tablet} {
    display: flex;
    img {
      width: 40px;
    }
  }
`;
const Styled5StarSection = styled.div`
  margin-top: 14px;
  margin-bottom: 5px;
  @media ${devices.tablet} {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;
const StyledTrustLogoSection = styled.div`
  flex-direction: column;
  .trustLogoReviews {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.smallX}px;
    line-height: 150%;
    color: ${colors.gray[800]};
  }
  @media ${devices.tablet} {
    display: flex;
    img {
      width: 100%;
    }
    .trustLogoReviews {
      text-align: left;
      font-size: 10px;
    }
  }
`;
const StyledTrustText = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.medium}px;
  line-height: 150%;
  color: ${colors.gray[800]};
  @media ${devices.tablet} {
    font-size: ${fontSizes.smallX}px;
    white-space: nowrap;
  }
`;
const TrustPilotBannerSection = () => {
  return (
    <StyledTrustPilotBannerSection>
      <StyledTrustLogoSection>
        <div>
          <picture>
            <source
              srcSet={`${config.basePath}/images/trustpilot-logo-top.svg`}
              type="image/png"
            />
            <img
              src={`${config.basePath}/images/trustpilot-logo-top.svg`}
              title="Trust Pilot Logo"
              alt="Trust Pilot Logo"
            />
          </picture>
        </div>
        <Styled5StarSection>
          <picture>
            <source
              srcSet={`${config.basePath}/images/5-star.svg`}
              type="image/png"
            />
            <img
              src={`${config.basePath}/images/5-star.svg`}
              title="5 Star Review"
              alt="5 Star Review"
            />
          </picture>
        </Styled5StarSection>
        <div className="trustLogoReviews">
          “Excellent” Rating on 3289 Reviews
        </div>
      </StyledTrustLogoSection>
      <StyledTrustText>
        Trusted by Over <b>50,000</b> businesses
      </StyledTrustText>
      <StyledIncLogoSection>
        <picture>
          <source
            srcSet={`${config.basePath}/images/trustpilot-500inc.svg`}
            type="image/png"
          />
          <img
            src={`${config.basePath}/images/trustpilot-500inc.svg`}
            title="Trust Pilot 500 Inc"
            alt="Trust Pilot 500 Inc"
          />
        </picture>
      </StyledIncLogoSection>
    </StyledTrustPilotBannerSection>
  );
};

export default TrustPilotBannerSection;
